import { memo } from 'react';
import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { UserRoundX } from 'lucide-react';

import InvitationShell from './InvitationShell';

/**
 * A valid invitation opened while signed in as someone else. Offers to sign out and continue with
 * the invited address, or to stay signed in (which leaves the invitation unaccepted).
 *
 * @param {object} props
 * @param {string} props.invitedEmail Address the invitation is for.
 * @param {string} props.signedInEmail Address of the current session.
 * @param {() => void} [props.onSignOut] Without it there is no sign-out button (the host cannot sign out).
 * @param {() => void} props.onStay
 */
const InvitationOtherAccountScreen = ({ invitedEmail, signedInEmail, onSignOut, onStay }) => {
  const { t } = useTranslation('people-access');

  return (
    <InvitationShell>
      <UserRoundX size={32} className="text-content-muted" aria-hidden />
      <div>
        <h1 className="m-0 text-xl font-semibold text-content">{t('invitation.otherAccount.title')}</h1>
        <p className="m-0 mt-1 text-sm text-content-muted">
          {t('invitation.otherAccount.subtitle', { email: invitedEmail, other: signedInEmail })}
        </p>
      </div>
      <div className="flex gap-2">
        {onSignOut ? (
          <Button size="md" onClick={onSignOut}>
            {t('invitation.otherAccount.signOut')}
          </Button>
        ) : null}
        <Button variant="secondary" size="md" data-autofocus onClick={onStay}>
          {t('invitation.otherAccount.stay')}
        </Button>
      </div>
    </InvitationShell>
  );
};

export default memo(InvitationOtherAccountScreen);
